export const deClientPortalOrderListPagePages = {
    orders: {
        orderListPage: {
            newOrder: 'Neuer Auftrag',
            tabs: {
                open: 'Offen',
                closed: 'Abgeschlossen',
                cancelled: 'Abgebrochen',
            },
            filters: {
                search: 'Auftrag suchen',
                status: 'Status',
                valuationDateFrom: 'Stichtag von',
                valuationDateTo: 'Stichtag bis',
                assignee: 'Zuständig',
                assigneeOptionsLoading: 'Optionen werden geladen...',
                assigneeOptionsEmpty: 'Keine Optionen verfügbar',
                resetAll: 'Alle Filter zurücksetzen',
                sortAriaLabel: 'Sortierung',
                sortTooltip: 'Aufträge sortieren',
                sortByOrderDate: 'Nach letztem Auftragsdatum',
                sortAlphabetically: 'Nach Alphabet A-Z',
            },
            emptyStates: {
                noOpenOrders: 'Keine offenen Aufträge vorhanden',
                showClosedOrders: 'Abgeschlossene Aufträge',
                noClosedOrders: 'Keine abgeschlossenen Aufträge vorhanden',
                showCancelledOrders: 'Abgebrochene Aufträge',
                noCancelledOrders: 'Keine abgebrochenen Aufträge vorhanden',
                showOpenOrders: 'Offene Aufträge',
                noFilteredOrders: 'Keine Aufträge zu Ihrer Auswahl gefunden',
                resetFilters: 'Filter zurücksetzen',
            },
            snackbar: {
                observerSaved: 'Ihre Änderungen wurden erfolgreich gespeichert',
            },
            cells: {
                assignee: 'Zuständig',
                notSet: 'Nicht festgelegt',
                orderDate: 'Beauftragungsdatum',
                valuationDateShort: 'Werterm.-stichtag',
            },
            observer: {
                protected: 'Als Zuständige/r dieses Auftrags beobachten Sie ihn automatisch.',
                platformUser: 'Sie können sich als Plattformnutzer nicht als Beobachter hinzufügen.',
                observing: 'Sie beobachten diesen Auftrag. Klicken, um nicht mehr zu beobachten.',
                notObserving: 'Sie beobachten diesen Auftrag nicht. Klicken, um zu beobachten.',
            },
            plausibility: {
                draft: 'Entwurf',
                draftWithVersion: 'Entwurf {{version}}',
                annotationCount_one: '{{count}} Anmerkung',
                annotationCount_other: '{{count}} Anmerkungen',
                goToPlausibility: 'Zur Plausibilisierung',
                actions: 'Plausibilisierung Aktionen',
                shareAnnotations: 'Anmerkungen teilen',
                annotationsAlreadyShared: 'Anmerkungen bereits geteilt',
                noAnnotations: 'Keine Anmerkungen vorhanden',
                fundApproveDraft: 'Fonds: Entwurf freigeben',
                kvgApproveDraft: 'KVG: Entwurf freigeben',
                approveDraft: 'Entwurf freigeben',
                fundAlreadyApproved: 'Fondsseitige Freigabe bereits erteilt',
                kvgAlreadyApproved: 'KVG-seitige Freigabe bereits erteilt',
                draftAlreadyApproved: 'Entwurf bereits freigegeben',
                approved: 'freigegeben',
                shared: 'geteilt',
                fundLabel: 'Fonds',
                kvgLabel: 'KVG',
                fundApprovalGranted: 'Freigabe Fonds erteilt',
                fundApprovalPending: 'Freigabe Fonds ausstehend',
                kvgApprovalGranted: 'Freigabe KVG erteilt',
                kvgApprovalPending: 'Freigabe KVG ausstehend',
                modal: {
                    cancel: 'Abbrechen',
                },
                appraiserSelection: {
                    title: 'Kein/e Gutachter/in zuständig',
                    description: 'Fügen Sie mindestens einen Gutachter/eine Gutachterin als Beobachter/in hinzu:',
                    loading: 'Lade Gutachter/innen...',
                    empty: 'Keine verknüpften Gutachter/innen für diesen Auftrag verfügbar.',
                    selectLabel: 'Gutachter/in',
                },
                handoverModal: {
                    title: 'Anmerkungen teilen',
                    primaryButton: 'Teilen',
                    imageAlt: 'teilen',
                    makeAnnotationsVisible: 'Alle Anmerkungen zu diesem Entwurf für den Gutachter/die Gutachterin sichtbar machen',
                    requestNewDraft: 'Neuen Entwurf gemäß der Anmerkungen anfordern',
                    infoText:
                        'Sie können weiterhin Anmerkungen zu diesem Entwurf hinzufügen, bearbeiten und löschen. Ihre Gutachterin/Ihr Gutachter wird sofort benachrichtigt.',
                },
                approvalModal: {
                    title: 'Entwurf freigeben',
                    primaryButton: 'Freigeben',
                    imageAlt: 'freigeben',
                    makeAnnotationsVisible: 'Alle Anmerkungen zu diesem Entwurf für den Gutachter/die Gutachterin sichtbar machen',
                    requestFinalizationWithAnnotations: 'Finalisierung des Gutachtens nach Einarbeitung der Anmerkungen anfordern',
                    requestFinalization: 'Finalisierung des Gutachtens anfordern',
                    infoText: 'Sie können nach der Freigabe Anmerkungen nicht mehr zu diesem Entwurf hinzufügen, bearbeiten oder löschen.',
                    confirmationLabel: 'Ich bestätige, dass ich den Entwurf zur Finalisierung freigebe.',
                },
                internalApprovalModal: {
                    title: 'Entwurf freigeben',
                    primaryButton: 'Freigeben',
                    imageAlt: 'freigeben',
                    fundApproval: 'Fondsseitige Freigabe erteilen',
                    confirmationLabel: 'Ich bestätige, dass ich diesen Entwurf freigebe.',
                },
            },
        },
    },
}
